const versionInfo = {
  version: '0.8.5',
  description: 'Tzuchi wallet option name change',
};

export default versionInfo;
